import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

// Values must match the tests.testType enum in ml-service.
export const TEST_TYPE_OPTIONS = [
  { value: "HARD_TISSUE", label: "Hard tissue" },
  { value: "SOFT_TISSUE", label: "Soft tissue" },
  { value: "OPG", label: "OPG" },
  { value: "IOPA", label: "IOPA" },
];

export const getTestTypeLabel = (value) =>
  TEST_TYPE_OPTIONS.find((o) => o.value === value)?.label || value || "--";

const TestTypeSelect = ({ value = "", onChange, minWidth = 180 }) => (
  <FormControl size="small" sx={{ minWidth }}>
    <InputLabel shrink>Scan type</InputLabel>
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      label="Scan type"
      displayEmpty
      notched
    >
      <MenuItem value="">All types</MenuItem>
      {TEST_TYPE_OPTIONS.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default TestTypeSelect;
